import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat.component';
import { SharedModule } from '../../shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [ChatComponent],
  imports: [CommonModule, SharedModule, MatProgressSpinnerModule],
  exports: [ChatComponent]
})
export class ChatModule { }
